module.exports = __webpack_public_path__ + "img/80.d20c8412.jpg";